import cx from 'classnames';
import Menu, { Props as MenuProps } from 'components/Menu';
import * as React from 'react';

import './styles/NavigationMenu.scss';

/**
 * ## [Menu](/internal/components/Menu) that's used specifically for navigation.
 *
 * ```example
 * <NavigationMenu>
 *   <MenuItem href="#">
 *     <Glyph name="remind-icon" size="large" />
 *     <span>MenuItem</span>
 *   </MenuItem>
 *   <MenuItem href="#">
 *     <Glyph name="remind-icon" size="large" />
 *     <span>MenuItem</span>
 *   </MenuItem>
 *   <MenuItem href="#">
 *     <Glyph name="remind-icon" size="large" />
 *     <span>MenuItem</span>
 *   </MenuItem>
 * </NavigationMenu>
 * ```
 */

class NavigationMenu extends React.Component<MenuProps> {
  render() {
    return (
      <Menu {...this.props} className={cx('NavigationMenu', this.props.className)}>
        {this.props.children}
      </Menu>
    );
  }
}

export default NavigationMenu;
